import { CaretUpOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Col, Row, Tooltip } from 'antd';
import NumberFormat from 'react-number-format';

import styles from './SkillBar.module.css';

interface SkillBarProps {
  name: string;
  color: string;
  grade?: number;
  average: number;
  tooltipText?: string;
}

const SkillBar: React.FC<SkillBarProps> = ({ average, color, grade, name, tooltipText = '' }) => {
  return (
    <Col>
      <Row justify="space-between">
        <span>
          {name}{' '}
          <Tooltip title={tooltipText}>
            <QuestionCircleOutlined data-testid={`skill-bar-tooltip-${name}`} />
          </Tooltip>
        </span>
        <span>
          {grade === undefined ? (
            <span>-</span>
          ) : grade <= -1 ? (
            'Bloqueado'
          ) : (
            <NumberFormat value={grade} displayType="text" />
          )}{' '}
        </span>
      </Row>
      <Row className={styles.bar__container}>
        <Row
          style={{ backgroundColor: color, width: `${grade && grade >= 0 ? grade : undefined}%` }}
        />
      </Row>
      <Row>
        <Col className={styles.bar__arrow} style={{ left: `${average}%` }}>
          <Row justify="center">
            <CaretUpOutlined />
          </Row>
          <Row justify="center">Média</Row>
          <Row justify="center">
            <NumberFormat value={average} displayType="text" />
          </Row>
        </Col>
      </Row>
    </Col>
  );
};

export default SkillBar;
